import { render, staticRenderFns } from "./MarketCheckerMenu.vue?vue&type=template&id=3530a2be&scoped=true&"
import script from "./MarketCheckerMenu.vue?vue&type=script&lang=js&"
export * from "./MarketCheckerMenu.vue?vue&type=script&lang=js&"
import style0 from "./MarketCheckerMenu.vue?vue&type=style&index=0&id=3530a2be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530a2be",
  null
  
)

export default component.exports